import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { QueryClient, useQuery } from 'react-query';
import { sortingOrder } from '../../../../../Utils/sortingOrder';
import moment from 'moment';
import { axiosInstance } from '../../../../../../config/axiosInstance';
import { globalEnv } from '../../../../../../config/baseConfig';
import { useTypedSelector } from '../../../../../../hooks/useTypeSelector';
import { HeaderItem } from '../../../../../Tables/TablesList/Components/common';

const queryClient = new QueryClient();

export function MeavanaUsersModal({
	setModalOpen,
	emailAdrs,
	setEmailAdrs
}: {
	setModalOpen: (isOpen: boolean) => void;
	emailAdrs: string[];
	setEmailAdrs: (emailAdrs: string[]) => void;
}) {
	const [page, setPage] = useState(1);
	const [sortOrder, setSortOrder] = useState(sortingOrder.DESCENDING);
	const [selectedHeader, setSelectedHeader] = useState('lastActive');
	const [searchQuery, setSearchQuery] = useState('');
	const [fetchedUsers, setfetchedUsers] = useState<any[]>([]);
	const [usersCount, setUsersCount] = useState(0);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const removeAllAdrs = () => {
		setEmailAdrs([]);
	};

	const addAllAdrs = () => {
		setEmailAdrs(fetchedUsers.map((item) => item.email));
	};

	const TableHeaders = () => {
		return (
			<tr>
				<div className="flex items-center mt-[8px] justify-center ml-2">
					<input
						id="default-checkbox"
						type="checkbox"
						checked={emailAdrs.length === fetchedUsers.length}
						onChange={() => {
							if (emailAdrs.length === fetchedUsers.length) removeAllAdrs();
							else addAllAdrs();
						}}
						className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300
					focus:ring-blue-500 dark:focus:ring-blue-600"
					/>
				</div>
				<HeaderItem
					name="Username"
					slugName="username"
					isCenter={false}
					selectedHeader={selectedHeader}
					setSelectedHeader={setSelectedHeader}
					sortOrder={sortOrder}
					setSortOrder={setSortOrder}
				/>

				<HeaderItem
					name="Email"
					slugName="email"
					isCenter={false}
					selectedHeader={selectedHeader}
					setSelectedHeader={setSelectedHeader}
					sortOrder={sortOrder}
					setSortOrder={setSortOrder}
				/>
				<HeaderItem
					name="Signup Date"
					slugName="createdAt"
					isCenter={true}
					selectedHeader={selectedHeader}
					setSelectedHeader={setSelectedHeader}
					sortOrder={sortOrder}
					setSortOrder={setSortOrder}
				/>
				<HeaderItem
					name="Last Active"
					slugName="lastActive"
					isCenter={true}
					selectedHeader={selectedHeader}
					setSelectedHeader={setSelectedHeader}
					sortOrder={sortOrder}
					setSortOrder={setSortOrder}
				/>
			</tr>
		);
	};

	const { data, isError, isFetching, isLoading } = useQuery(
		['users', page, selectedHeader, sortOrder, searchQuery],
		() => fetchUsers(page, ACCESS_TOKEN),
		{
			cacheTime: 0,
			keepPreviousData: false,
			staleTime: 5000,
			refetchOnWindowFocus: false
		}
	);

	useEffect(() => {
		if (data?.hasMore) {
			queryClient.prefetchQuery(['users', page + 1], () =>
				fetchUsers(page + 1, ACCESS_TOKEN)
			);
		}
	}, [data, page, queryClient]);

	useEffect(() => {
		if (data != null) {
			setfetchedUsers(data.users);
			setUsersCount(data.meta.total);
			console.log(data.meta.total);
		}
	}, [data]);

	useEffect(() => {
		const intervalId = setInterval(() => {
			window.location.reload();
		}, 1000 * 60 * 20);
		return () => clearInterval(intervalId);
	}, []);

	async function fetchUsers(page: number, token: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + token
			}
		};

		const { data } = await axiosInstance.get(
			globalEnv.BASE_URL +
				`/admin/user/get-all?page=${page}&sortby=${selectedHeader}&order=${sortOrder}${
					searchQuery ? '&filter=' + encodeURIComponent(searchQuery) : ''
				}`,
			config
		);
		return data;
	}

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
						w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<div
				className="relative bg-gray-300 w-full max-h-screen overflow-y-auto
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="flex flex-col justify-center px-4 py-2">
					<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xl font-bold mb-2 px-3 self-center">
						Selected non meavana Email Addresses to be contacted
					</h3>

					<div className="w-full mt-2 pr-1.5 mb-2 px-3">
						<input
							className="inputStyle"
							id="grid-last-name"
							type="text"
							placeholder="Search"
							onChange={(e) => {
								setSearchQuery(e.target.value);
							}}
							value={searchQuery}
						/>
					</div>

					<h3 className="mt-3 text-gray-700 dark:text-gray-300 text-md font-bold mb-2 px-3">
						{`Selected users: ${emailAdrs.length}`}
					</h3>
					<div>
						<div className="overflow-x-auto ">
							<table className="table-auto w-full">
								{isFetching || isLoading || isError ? (
									<></>
								) : (
									<thead className="text-xs font-bold uppercase dark:text-primary-text-dark text-primary-text-light">
										<TableHeaders />
									</thead>
								)}
								{isFetching || isLoading || isError ? (
									<></>
								) : (
									<tbody className="text-sm divide-y divide-gray-300 dark:divide-gray-600 transition-all duration-500">
										{data.users.length > 0 &&
											data.users.map((item: any, index: number) => (
												<TableData
													username={item.username}
													email={item.email}
													createdAt={item.createdAt}
													lastActive={item.lastActive}
													isSelected={item.isSelected}
													selectedEmails={emailAdrs}
													setSelectedEmails={setEmailAdrs}
													index={index}
												/>
											))}
									</tbody>
								)}
							</table>
						</div>
					</div>
				</div>
			</div>

			<div
				className="flex flex-row justify-end pt-3 pb-2 px-6 space-x-2 -mt-1
						bg-gray-300 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<button
					data-modal-toggle="defaultModal"
					className="btn btn-outline btn-primary btn-sm mr-1 "
					type="button"
					style={{ transition: 'all .15s ease' }}
					onClick={() => {
						setModalOpen(false);
					}}
				>
					Done
				</button>
			</div>
		</div>
	);
}

type ContactUser = {
	username?: string;
	email: string;
	phone?: string;
	createdAt?: Date;
	lastActive?: Date;
	isSelected: boolean;
	index: number;
	selectedEmails: string[];
	setSelectedEmails: (selectedEmails: string[]) => void;
};

const TableData = (props: ContactUser) => {
	const [isChecked, setIsChecked] = useState(
		props.selectedEmails.includes(props.email)
	);

	useEffect(() => {
		setIsChecked(props.selectedEmails.includes(props.email));
	}, [props.selectedEmails]);

	const removeAdr = () => {
		const updatedAdrs = props.selectedEmails.slice();
		updatedAdrs.splice(props.index, 1);
		props.setSelectedEmails(updatedAdrs);
		setIsChecked(false);
		// props.setIsChanged(true);
	};

	const addAdr = () => {
		const updatedAdrs = props.selectedEmails.slice();
		updatedAdrs.push(props.email);
		props.setSelectedEmails(updatedAdrs);
		setIsChecked(true);
		// props.setIsChanged(true);
	};

	return (
		<tr>
			<td className="">
				<div className="flex justify-center items-center ml-2">
					<input
						id="default-checkbox"
						type="checkbox"
						checked={isChecked}
						onChange={() => {
							if (isChecked) removeAdr();
							else addAdr();
						}}
						className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300
					focus:ring-blue-500 dark:focus:ring-blue-600"
					/>
				</div>
			</td>
			<td className="p-2 whitespace-nowrap">
				<div className="text-left font-medium dark:text-gray-400">
					{props.username != null ? props.username : '-'}
				</div>
			</td>
			<td className="p-2 whitespace-nowrap">
				<div className="text-left font-medium dark:text-gray-400">
					{props.email != null ? props.email : '-'}
				</div>
			</td>

			<td className="p-2 whitespace-nowrap">
				<div className="text-center font-medium dark:text-gray-400">
					{moment(props.createdAt).format('MM/DD/YYYY - HH:mm')}
				</div>
			</td>
			<td className="p-2 whitespace-nowrap">
				<div className="text-center font-medium dark:text-gray-400">
					{moment(props.lastActive).format('MM/DD/YYYY - HH:mm')}
				</div>
			</td>
		</tr>
	);
};
